// UK postcode and phone canonicalisation + validation helpers.
// Mirrors the server-side rules in app/services/uk_postcode.rb and
// app/services/uk_phone.rb. Keep the two in sync when either changes.

const UK_POSTCODE_FORMAT = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i;

export function canonicaliseUkPostcode(raw) {
  if (raw == null) return null;
  const compact = String(raw).toUpperCase().replace(/\s+/g, '');
  if (compact.length < 5 || compact.length > 7) return null;
  const inward = compact.slice(-3);
  const outward = compact.slice(0, -3);
  return `${outward} ${inward}`;
}

export function validUkPostcode(raw) {
  if (raw == null || String(raw).trim() === '') return false;
  return UK_POSTCODE_FORMAT.test(String(raw).trim());
}

export function canonicaliseUkPhone(raw) {
  if (raw == null) return null;
  const compact = String(raw).replace(/[\s\-().]/g, '');
  if (compact === '') return null;

  let digits;
  if (compact.startsWith('+44')) {
    digits = compact.slice(3);
  } else if (compact.startsWith('44') && compact.length === 12) {
    digits = compact.slice(2);
  } else if (compact.startsWith('0')) {
    digits = compact.slice(1);
  } else {
    digits = compact;
  }

  if (!/^\d+$/.test(digits)) return null;
  if (digits.length < 9 || digits.length > 10) return null;
  return `+44${digits}`;
}

export function validUkPhone(raw) {
  return canonicaliseUkPhone(raw) !== null;
}
